export default {
    getDataTableOptions: state => state.dataTableOptions,
    getActions: state => state.actions,
    getHeaderFields: state => state.headerFields,
    getSearchModalFields: state => state.searchFields
}
